import * as React from "react";
import CouncilIdentityBadge, { ICouncilIdentityBadge } from "src/components/general/CouncilIdentity";
import People from "../../../general/People";
import {
  faLevelDownAlt,
  faLevelUpAlt
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { ICouncil } from "src/interfaces";
import { FormatNumber } from "src/components/utils/FormatNumber";

interface IProps {
  council: ICouncil;
  year: string;
  ordinal: number;
  residents: number;
  nonResidents: number;
  growth: number;
  people: number;
  trans: number;
}



export default class SingleCouncil extends React.PureComponent<
IProps,
{},
ICouncilIdentityBadge> {
  public render() {
    return (
      <div className="c-single-council w-full flex">
        <div className="flex flex-col pr-4 w-4/5">
          <div className="c-single-council__identity">
            <CouncilIdentityBadge
              name={ this.props.council.name }
              badge={ this.props.ordinal }
              modifier="justify-left"
            />
          </div>
          <div className="c-single-council__content">
            <People
              normal={this.props.people}
              trans={this.props.trans} />
            <p className="font-bold pt-2">
              { FormatNumber( this.props.residents, 0 ) } Residents
              <span className="opacity-50">
                {" "}
                + { FormatNumber( this.props.nonResidents, 0 ) } non-resident workers
              </span>
            </p>
          </div>
        </div>
        <div className="flex flex-col self-center w-1/5">
          <div className="text-center lg:text-right xl:text-right">
            <p className="block sm:hidden md:hidden">Population Growth</p>
          </div>
          <div className="self-center">
            <span className="c-single-council__data">{this.props.growth} %</span>
            <FontAwesomeIcon
              className="c-single-council__icon ml-4 mt-4 yellow-text"
              icon={this.props.growth > 0 ? faLevelUpAlt : faLevelDownAlt}
            />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/report/councilArea/PeopleLivingIn/SingleCouncil.tsx